module.exports = __webpack_public_path__ + "img/facturas.0c1ed8e0.png";